import { z } from 'zod';
import { ElectronicAccountTypeT } from '@lotushealth/lotushealth_js_sdk/schemas';
import type { UpdateBankingDetailsRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

export type BankAccountType = UpdateBankingDetailsRequestT['accountType'];

export const ACCOUNT_TYPES: ReadonlyArray<BankAccountType> = [
  ElectronicAccountTypeT.personalChecking,
  ElectronicAccountTypeT.personalSavings,
  ElectronicAccountTypeT.businessChecking,
  ElectronicAccountTypeT.businessSavings,
];

const accountTypeSchema = z.enum([
  ElectronicAccountTypeT.personalChecking,
  ElectronicAccountTypeT.personalSavings,
  ElectronicAccountTypeT.businessChecking,
  ElectronicAccountTypeT.businessSavings,
]);

export const bankingDetailsSchema: z.ZodType<UpdateBankingDetailsRequestT> = z.object({
  accountHolderName: z.string().trim().min(1, 'Account holder name is required'),
  routingNumber: z
    .string()
    .trim()
    .min(1, 'Routing number is required')
    .regex(/^\d+$/, 'Routing number must contain only digits')
    .length(9, 'Routing number must be exactly 9 digits'),
  accountNumber: z
    .string()
    .trim()
    .min(1, 'Account number is required')
    .regex(/^\d+$/, 'Account number must contain only digits')
    .min(4, 'Account number must be at least 4 digits')
    .max(17, 'Account number must be at most 17 digits'),
  accountType: accountTypeSchema,
});

export interface BankingDetailsFormValues {
  bankingDetails: UpdateBankingDetailsRequestT;
}

export const bankingDetailsFormSchema: z.ZodType<BankingDetailsFormValues> = z.object({
  bankingDetails: bankingDetailsSchema,
});

export type ValidateBankingSuccess = { success: true; data: BankingDetailsFormValues };
export type ValidateBankingError = { success: false; error: z.ZodError<BankingDetailsFormValues> };
export type ValidateBankingResult = ValidateBankingSuccess | ValidateBankingError;
